/**
 * SDGsカテゴリー
 */
export const SDGsCategoryCode = {
  sdgs1: '1',
  sdgs2: '2',
  sdgs3: '3',
  sdgs4: '4',
  sdgs5: '5',
  sdgs6: '6',
  sdgs7: '7',
  sdgs8: '8',
  sdgs9: '9',
  sdgs10: '10',
  sdgs11: '11',
  sdgs12: '12',
  sdgs13: '13',
  sdgs14: '14',
  sdgs15: '15',
  sdgs16: '16',
  sdgs17: '17',
} as const

export const SDGsCategoryLabel: { [key: string]: string } = {
  [SDGsCategoryCode.sdgs1]: '貧困をなくそう',
  [SDGsCategoryCode.sdgs2]: '飢餓をゼロに',
  [SDGsCategoryCode.sdgs3]: 'すべての人に健康と福祉を',
  [SDGsCategoryCode.sdgs4]: '質の高い教育をみんなに',
  [SDGsCategoryCode.sdgs5]: 'ジェンダー平等を実現しよう',
  [SDGsCategoryCode.sdgs6]: '安全な水とトイレを世界中に',
  [SDGsCategoryCode.sdgs7]: 'エネルギーをみんなに そしてクリーンに',
  [SDGsCategoryCode.sdgs8]: '働きがいも経済成長も',
  [SDGsCategoryCode.sdgs9]: '産業と技術革新の基盤をつくろう',
  [SDGsCategoryCode.sdgs10]: '人や国の不平等をなくそう',
  [SDGsCategoryCode.sdgs11]: '住み続けられるまちづくりを',
  [SDGsCategoryCode.sdgs12]: 'つくる責任 つかう責任',
  [SDGsCategoryCode.sdgs13]: '気候変動に具体的な対策を',
  [SDGsCategoryCode.sdgs14]: '海の豊かさを守ろう',
  [SDGsCategoryCode.sdgs15]: '陸の豊かさも守ろう',
  [SDGsCategoryCode.sdgs16]: '平和と公正をすべての人に',
  [SDGsCategoryCode.sdgs17]: 'パートナーシップで目標を達成しよう',
}

export const SDGsCategoryValues = Object.entries(SDGsCategoryLabel).map(([code, value]) => ({
  code,
  value,
}))
